import React from 'react'

const Contact = props => (
  <section id="contact">
    <div className="inner">
      <section>
        <div className="contact-method">
          <span className="icon alt fa-home"></span>
          <h3>Miejsce zajęć</h3>
          <span>
            Podhalańska Państwowa Uczelnia Zawodowa w Nowym Targu
            <br />
            ul. Kokoszków 71
            <br />
            34-400 Nowy Targ
          </span>
        </div>
      </section>
      <section className="split">
        <section>
            <h3>Kontakt</h3>
            
          <div className="contact-method">
            <span className="icon alt fa-envelope"></span>
              <a href="mailto:pone.nbp@ppuz.edu.pl">pone.nbp@ppuz.edu.pl</a>
          </div>
          <div className="contact-method">
            <span className="icon alt fa-link"></span>
            <a href="http://www.ppuz.edu.pl/sekretariat-xviii.html">sekretariat PONE</a>
        </div>
        <div className="contact-method">
            <span className="icon alt fa-users"></span>
            <p>
              koordynator: <strong>dr Paweł Zamora</strong><br /><br />
              zespół projektowy: <br /><strong>dr Dorota Kuder<br />mgr Andrzej Sasuła<br />lic. Magdalena Smoleń<br />dr Marcin Surówka<br />dr Agnieszka Witoń<br />dr hab. Robert Włodarczyk, prof. UEK</strong>
            </p>
          </div>
        </section>
      </section>
    </div>
  </section>
)

export default Contact
